import { fetchFormDataCall, fetchLoginCall } from "../ajax";
import { API_CONSTANTS, API_METHODS } from "../api-constant";

export const GetAllDeviceForAdmin = async () => {
  const url = `${API_CONSTANTS.GET_ALL_DEVICE_FOR_ADMIN}`;
  return fetchLoginCall(url, API_METHODS.GET);
};

export const GetDeviceAssignedForProfessionalById = async () => {
  const url = `${API_CONSTANTS.GET_DEVICE_ASSIGNED_PROFESSION_BY_ID}`;
  return fetchLoginCall(url, API_METHODS.GET);
};

export const AddDeviceForHealthProfessional = async (formData) => {
  const url = `${API_CONSTANTS.ADD_DEVICE_FOR_HEALTH_PROFESSIONAL}`;
  return fetchFormDataCall(url, API_METHODS.POST, formData);
};

export const UpdateDeviceByID = async (formData) => {
  const url = `${API_CONSTANTS.UPDATE_DEVICE_BY_ID}`;
  return fetchFormDataCall(url, API_METHODS.POST, formData);
};

export const DeleteDeviceByID = async (deviceId) => {
  const url = `${API_CONSTANTS.DELETE_DEVICE_BY_ID}?deviceId=${deviceId}`;
  return fetchLoginCall(url, API_METHODS.DELETE);
};

export const GetDeviceById = async (deviceId) => {
  const url = `${API_CONSTANTS.GET_DEVICE_BY_ID}?deviceId=${deviceId}`;
  return fetchLoginCall(url, API_METHODS.GET);
};

export const GetAllDevice = async (payload) => {
  const url = `${API_CONSTANTS.GET_ALL_DEVICE}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const GetAllDeviceHealthProfessional = async (payload) => {
  const url = `${API_CONSTANTS.GET_ALL_DEVICE_HP}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const ConfirmDeviceRemoval = async (payload) => {
  const url = `${API_CONSTANTS.CONFIRM_DEVICE_REMOVAL}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};

export const ConfirmDeviceReassignment = async (payload) => {
  const url = `${API_CONSTANTS.CONFIRM_DEVICE_REASSIGNMENT}`;
  return fetchLoginCall(url, API_METHODS.POST, payload);
};
